export const APP_VERSION = process.env.VITE_APP_VERSION || '2.1.10'
export const APP_RELEASE_DATE = process.env.VITE_APP_RELEASE_DATE || ''

export const APP_RELEASE_LABEL = (() => {
  if (!APP_RELEASE_DATE) return `v${APP_VERSION}`
  const parsed = new Date(APP_RELEASE_DATE)
  if (Number.isNaN(parsed.getTime())) return `v${APP_VERSION}`
  const formatted = parsed.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
  return `v${APP_VERSION} · ${formatted}`
})()
